/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Warning_Unknown_FieldInputs */

const en_warning_unknown_field = /** @type {(inputs: Warning_Unknown_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unknown field ${i?.field}, searched as text`)
};

const de_warning_unknown_field = /** @type {(inputs: Warning_Unknown_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unbekanntes Feld ${i?.field}, wird als Text gesucht`)
};

/**
* | output |
* | --- |
* | "Unknown field {field}, searched as text" |
*
* @param {Warning_Unknown_FieldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_unknown_field = /** @type {((inputs: Warning_Unknown_FieldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_Unknown_FieldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_unknown_field(inputs)
	return en_warning_unknown_field(inputs)
});